function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.787 3.137a.577.577 0 00-.597-.092L.36 14.273a.591.591 0 00-.359.552.59.59 0 00.37.544l7.387 2.906a.577.577 0 00.546-.066l9.8-7.06a.578.578 0 01.79.1.597.597 0 01-.047.807l-8.166 7.972a.595.595 0 00-.179.425v7.958a.58.58 0 001.086.298l3.695-6.412a.29.29 0 01.393-.11l6.796 3.782c.162.09.356.098.523.02a.59.59 0 00.329-.412l4.666-21.865a.605.605 0 00-.202-.575z",
  fill: "currentColor"
})));